/**
 * Foot-gun entity payload — a recurring mistake or anti-pattern the
 * LLM-wiki tracks across threads.
 *
 * `typical_phrasings` is the list of natural-language phrasings the
 * extractor has seen for this foot-gun; the embedding(s) live in the
 * `entity_embeddings` row keyed by `slot = 'primary'` (D18 / ADR-0007).
 *
 * No `severity` field (D21): the design deliberately omits a severity
 * scale — foot-guns are surfaced by frequency and recency, not by a
 * subjective rating.
 *
 * Design context: docs/plans/2026-05-26-llm-wiki-entities-prototype-design.md
 */

import { z } from 'zod';

export const footGunPayloadSchema = z.object({
  typical_phrasings: z.array(z.string()).default([]),
});

export type FootGunPayload = z.infer<typeof footGunPayloadSchema>;
